/* tslint:disable */
/* eslint-disable */
/**
 * Credify API doc version 1
 * API documentations version 1.
 *
 * The version of the OpenAPI document: 1.0.0-oas3
 * Contact: dev@credify.one
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { VaultBackupResponse } from '../model';
/**
 * VaultApi - axios parameter creator
 * @export
 */
export const VaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This retrieves backup stored in the vault service. This may contain the object of VNPT eKYC result. 
         * @summary Gets Encrypted Backup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEncryptedBackup: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/vault/backup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VaultApi - functional programming interface
 * @export
 */
export const VaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VaultApiAxiosParamCreator(configuration)
    return {
        /**
         * This retrieves backup stored in the vault service. This may contain the object of VNPT eKYC result. 
         * @summary Gets Encrypted Backup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEncryptedBackup(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VaultBackupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEncryptedBackup(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VaultApi - factory interface
 * @export
 */
export const VaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VaultApiFp(configuration)
    return {
        /**
         * This retrieves backup stored in the vault service. This may contain the object of VNPT eKYC result. 
         * @summary Gets Encrypted Backup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEncryptedBackup(options?: any): AxiosPromise<VaultBackupResponse> {
            return localVarFp.getEncryptedBackup(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VaultApi - interface
 * @export
 * @interface VaultApi
 */
export interface VaultApiInterface {
    /**
     * This retrieves backup stored in the vault service. This may contain the object of VNPT eKYC result. 
     * @summary Gets Encrypted Backup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultApiInterface
     */
    getEncryptedBackup(options?: AxiosRequestConfig): AxiosPromise<VaultBackupResponse>;

}

/**
 * VaultApi - object-oriented interface
 * @export
 * @class VaultApi
 * @extends {BaseAPI}
 */
export class VaultApi extends BaseAPI implements VaultApiInterface {
    /**
     * This retrieves backup stored in the vault service. This may contain the object of VNPT eKYC result. 
     * @summary Gets Encrypted Backup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VaultApi
     */
    public getEncryptedBackup(options?: AxiosRequestConfig) {
        return VaultApiFp(this.configuration).getEncryptedBackup(options).then((request) => request(this.axios, this.basePath));
    }
}
